import React, { useEffect, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material"; // Import Typography from Material-UI
import OrderTable from "../../../Components/Table/OrderTable";
import { GetOrder } from "../../../APIs/Function/Order/GetOrder";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";

const Order = () => {
  const [orderData, setOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [order, setOrder] = useState("");

  const handleOrder = async () => {
    try {
      setLoading(true);
      let res = await GetOrder(order);
      if (order) {
        setOrderData(res.r);
      } else {
        setOrderData((prevData) => [...prevData, ...res.r]);
      }
      setOrderData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }

    try {
      await SearchDebouncing(8, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeOrder = (e) => {
    setOrder(e.target.value);
  };

  useEffect(() => {
    handleOrder(order);
  }, [order]);

  return (
    <>
      <Box sx={{ boxSizing: "border-box", p: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Searchbar placeholder={"search"} onChange={handleSearch} />
          <FormControl sx={{ width: "25%" }}>
            <InputLabel sx={{ bgcolor: "#FFF" }}>
              Filter By Order Status
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={order}
              label="User Type"
              onChange={(e) => handleChangeOrder(e)}
            >
              <MenuItem disabled value={""}>
                Filter By Order Status
              </MenuItem>
              <MenuItem value={'0'}>Pending</MenuItem>
              <MenuItem value={1}>Ready To Dispatch</MenuItem>
              <MenuItem value={2}>Completed</MenuItem>
            </Select>{" "}
          </FormControl>
        </Box>
        <Box sx={{ height: "80vh" }}>
          {searched && searchData.length > 0 ? (
            <OrderTable
              orderData={searchData}
              setOrderData={setOrderData}
              loading={loading}
              setLoading={setLoading}
            />
          ) : !searched ? (
            <OrderTable
              orderData={orderData}
              setOrderData={setOrderData}
              loading={loading}
              setLoading={setLoading}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default Order;
